import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import WagmiConnect from "components/WagmiConnect/WagmiConnect";
import { fetchSigner } from "@wagmi/core";
import Edit from "@material-ui/icons/Edit";
import { MenuItem, Select } from "@material-ui/core";
import { tierName } from "views/RewardTier/const";
import { setCollectionToTier } from "views/RewardTier/reward";
import { setCollectionToPayee } from "views/RewardTier/reward";
import { collectionService } from "services/collectionService";
import { toast } from "react-toastify";
import { ethers } from "ethers";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    width: "280px",
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  formSection: {
    marginBottom: theme.spacing(2),
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

export default function EditCollectionTier({ collection, reload }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [formValues, setFormValues] = useState({
    rewardTier: collection?.rewardTier,
    rewardPayee: collection?.rewardPayee,
  });
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (field) => {
    setLoading(true);
    try {
      const signer = await fetchSigner();
      if (!signer) {
        throw new Error("No signer");
      }
      if (field === "rewardTier") {
        await setCollectionToTier(
          signer,
          collection.address,
          formValues.rewardTier
        );
      } else if (field === "rewardPayee") {
        await setCollectionToPayee(
          signer,
          collection.address,
          formValues.rewardPayee
        );
      }
      // call api
      await collectionService.update(collection.id, {
        [field]: formValues[field],
      });
      toast.success("Update successfully");
      reload();
    } catch (e) {
      console.error(e);
      alert("Error updating tier");
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setFormValues({
      rewardTier: collection?.rewardTier,
      rewardPayee: collection?.rewardPayee,
    });
  }, [collection]);

  if (
    !ethers.utils.isAddress(collection?.address) ||
    +collection?.address === 0
  ) {
    return <div />;
  }

  return (
    <>
      <Button startIcon={<Edit />} size="small" onClick={handleOpen}>
        {tierName[collection?.rewardTier]}
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Edit Collection Tier</h2>

            <WagmiConnect />
            <p></p>

            <div className={classes.form}>
              <div className={classes.formSection}>
                <TextField
                  className={classes.textField}
                  label="Reward payee"
                  name="rewardPayee"
                  type="string"
                  value={formValues.rewardPayee}
                  onChange={handleChange}
                />
                <Button
                  className={classes.submitButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  onClick={() => handleSubmit("rewardPayee")}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </div>

              <p></p>

              <div className={classes.formSection}>
                <Select
                  className={classes.textField}
                  label="Collection reward tier"
                  name="rewardTier"
                  value={formValues.rewardTier}
                  onChange={handleChange}
                >
                  <MenuItem value="0"> {tierName[0]} </MenuItem>
                  <MenuItem value="1"> {tierName[1]} </MenuItem>
                  <MenuItem value="2"> {tierName[2]} </MenuItem>
                  <MenuItem value="3"> {tierName[3]} </MenuItem>
                </Select>
                <Button
                  className={classes.submitButton}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading}
                  onClick={() => handleSubmit("rewardTier")}
                >
                  {loading ? "Loading..." : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </>
  );
}

// create props validation
EditCollectionTier.propTypes = {
  collection: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string,
    description: PropTypes.string,
    rewardTier: PropTypes.number,
    rewardPayee: PropTypes.string,
  }).isRequired,
  reload: PropTypes.func.isRequired,
};
